module.exports = __webpack_public_path__ + "img/561496898.532a70ca.jpg";